<nav
  class="ui-sidenav ui-text-primary h-dvh sticky top-0 overflow-hidden flex flex-col transition-[width] duration-300"
  [class.w-60]="!renderCollapsed()"
  [class.w-[72px]]="renderCollapsed()"
>
  <!-- Header -->
  <div
    [class]="
      'border-b border-(--ui-border-split) p-3 ' +
      (renderCollapsed() ? 'flex flex-col items-center gap-2' : 'flex items-center justify-between')
    "
  >
    @if (!renderCollapsed()) {
    <a [routerLink]="home()" class="flex items-stretch gap-2.5 w-full min-w-0" aria-label="Proteor GACO">
      <!-- Marque officielle Proteor (4 quartiers, bleu #335fb1) -->
      <svg class="shrink-0 h-11 w-auto" viewBox="46 100 312 318" aria-hidden="true">
        <g transform="matrix(1.3333333,0,0,-1.3333333,0,543.344)" fill="#335fb1">
          <g transform="translate(37.8089,233.6636)"><path d="m 0,0 c 0,-13.035 105.446,-8.546 105.446,-8.546 0,0 2.021,104.1 -11.002,104.179 C 45.736,87.64 7.4,48.898 0,0" /></g>
          <g transform="translate(264.2381,233.6636)"><path d="m 0,0 c -0.018,-13.035 -105.464,-8.546 -105.464,-8.546 0,0 -2.009,104.1 11.019,104.179 C -45.754,87.64 -7.406,48.898 0,0" /></g>
          <g transform="translate(37.8089,198.7774)"><path d="m 0,0 c 0,13.041 105.446,8.55 105.446,8.55 0,0 2.021,-104.097 -11.002,-104.18 C 45.736,-87.627 7.4,-48.898 0,0" /></g>
          <g transform="translate(264.2381,198.7774)"><path d="m 0,0 c -0.018,13.041 -105.464,8.55 -105.464,8.55 0,0 -2.009,-104.097 11.019,-104.18 C -45.754,-87.627 -7.406,-48.898 0,0" /></g>
        </g>
      </svg>
      <!-- Lockup : « GACO » en haut aligné à droite (sans fond ni bordure), wordmark « PROTEOR » en bas.
           flex-col-reverse inverse l'affichage (l'ordre DOM reste PROTEOR puis GACO) sans toucher au SVG. -->
      <span class="flex flex-col-reverse items-start justify-between py-0.5 gap-1 min-w-0">
        <svg class="ui-text-primary h-5 w-auto" viewBox="386 264 802 144" aria-label="Proteor">
          <g transform="matrix(1.3333333,0,0,-1.3333333,0,543.344)" fill="currentColor">
            <g transform="translate(306.0335,199.9248)"><path d="m 0,0 v -40.209 h 12.452 c 7.935,0 14.282,3.445 19.055,10.292 2.634,3.708 3.893,8.006 3.893,12.968 0,2.922 -0.523,5.599 -1.616,8.052 C 30.176,-2.983 24.125,0 15.566,0 Z m 15.935,6.021 c 5.706,0 9.724,-0.238 12.06,-0.734 14.515,-3.112 21.766,-11.275 21.766,-24.512 0,-4.268 -1.148,-8.282 -3.472,-12.045 -2.307,-3.771 -5.337,-6.725 -9.094,-8.9 -8.077,-4.609 -16.225,-6.913 -24.511,-6.913 H 0 V -94.444 H -12.844 V 6.021 Z" /></g>
            <g transform="translate(378.8138,199.7998)"><path d="m 0,0 v -38.419 c 7.441,-0.185 13.111,0.273 16.969,1.36 4.517,0.776 8.298,2.976 11.346,6.663 3.049,3.688 4.583,7.84 4.583,12.434 0,6.104 -2.271,11.148 -6.788,15.065 -1.599,1.42 -4.077,2.377 -7.406,2.897 z m 14.045,6.146 c 0.487,-0.092 2.211,-0.176 5.171,-0.289 7.875,-0.246 14.235,-2.216 19.097,-5.896 5.628,-4.19 8.421,-10.026 8.421,-17.572 0,-1.102 -0.094,-2.187 -0.261,-3.272 l -0.101,-0.374 c -3.453,-10.396 -11.501,-17.216 -24.167,-20.476 -0.838,-0.253 -3.382,-0.889 -7.673,-1.887 0.095,-0.071 0.226,-0.279 0.44,-0.627 L 58.884,-93.72 c 0.095,0 0.118,-0.133 0.118,-0.355 l 0.155,0.106 c -0.095,-0.062 -0.178,-0.209 -0.256,-0.35 L 43.941,-94.228 0,-43.448 V -94.319 H -1.516 -12.34 c -0.183,-0.108 -0.386,-0.054 -0.635,0.091 V 6.146 Z" /></g>
            <g transform="translate(497.6566,201.4136)"><path d="m 0,0 c -12.659,0 -23.031,-5.004 -31.181,-15.073 -4.422,-5.507 -7.364,-13.32 -8.784,-23.38 0.095,-0.16 0.042,-0.281 -0.106,-0.365 -0.262,-2.44 -0.393,-4.897 -0.393,-7.403 0,-17.617 5.73,-30.369 17.212,-38.345 6.224,-4.359 13.041,-6.746 20.506,-7.159 8.018,-0.41 15.418,1.299 22.301,5.162 6.823,3.827 11.917,9.296 15.316,16.398 3.395,7.052 5.095,15.168 5.095,24.304 0,18.202 -5.914,31.216 -17.725,39.08 C 15.37,-2.24 7.953,0 0,0 m 47.348,-19.438 c 3.12,-5.386 5.081,-10.019 5.925,-13.953 0.588,-2.696 0.886,-6.951 0.886,-12.818 0,-18.009 -7.537,-32.169 -22.634,-42.482 -9.7,-6.609 -20.315,-9.923 -31.775,-9.923 -9.153,0 -17.818,2.149 -26.009,6.41 -8.214,4.262 -14.842,10.14 -19.875,17.602 -5.777,8.625 -8.672,18.334 -8.672,29.133 0,14.407 5.23,26.735 15.733,36.964 5.432,5.266 11.863,9.293 19.317,12.116 7.465,2.802 15.007,4.006 22.645,3.578 h 0.749 c 9.111,-0.85 17.551,-3.566 25.26,-8.158 7.692,-4.612 13.843,-10.776 18.45,-18.469" /></g>
            <g transform="translate(629.9623,199.9341)"><path d="M 0,0 H -30.55 V -94.465 H -43.508 V 0 H -74.171 V 6.003 H 0 Z" /></g>
            <g transform="translate(691.9252,205.937)"><path d="m 0,0 v -6.137 h -37.933 v -38.429 h 32.649 v -6.383 H -37.933 V -94.1 H 0 v -6.368 H -50.64 V 0 Z" /></g>
            <g transform="translate(754.2679,201.4136)"><path d="m 0,0 c -12.672,0 -23.05,-5.004 -31.192,-15.073 -4.447,-5.507 -7.371,-13.32 -8.779,-23.38 0.089,-0.16 0.041,-0.281 -0.137,-0.365 -0.261,-2.44 -0.392,-4.897 -0.392,-7.403 0,-17.617 5.777,-30.369 17.236,-38.345 6.194,-4.359 13.041,-6.746 20.506,-7.159 8.024,-0.41 15.442,1.299 22.301,5.162 6.829,3.827 11.923,9.296 15.311,16.398 3.399,7.052 5.111,15.168 5.111,24.304 0,18.202 -5.944,31.216 -17.76,39.08 C 15.376,-2.24 7.958,0 0,0 m 47.365,-19.438 c 3.073,-5.386 5.046,-10.019 5.914,-13.953 0.546,-2.696 0.856,-6.951 0.856,-12.818 0,-18.009 -7.549,-32.169 -22.628,-42.482 -9.712,-6.609 -20.285,-9.923 -31.769,-9.923 -9.141,0 -17.848,2.149 -26.021,6.41 -8.226,4.262 -14.823,10.14 -19.858,17.599 -5.789,8.618 -8.666,18.33 -8.666,29.136 0,14.407 5.225,26.729 15.703,36.964 5.457,5.266 11.894,9.293 19.359,12.116 7.441,2.802 14.99,4.006 22.586,3.578 h 0.772 c 9.142,-0.85 17.552,-3.566 25.273,-8.158 7.679,-4.612 13.848,-10.776 18.479,-18.469" /></g>
            <g transform="translate(829.1693,199.7998)"><path d="m 0,0 v -38.429 c 7.453,-0.187 13.088,0.283 16.952,1.37 4.517,0.758 8.309,2.976 11.363,6.651 3.068,3.7 4.578,7.849 4.578,12.44 0,6.093 -2.236,11.142 -6.8,15.059 -1.557,1.432 -4.03,2.389 -7.388,2.909 z m 14.045,6.137 c 0.505,-0.093 2.228,-0.172 5.171,-0.288 7.87,-0.238 14.253,-2.208 19.097,-5.888 5.624,-4.202 8.399,-10.047 8.399,-17.584 0,-1.108 -0.078,-2.175 -0.196,-3.275 l -0.173,-0.359 c -3.418,-10.396 -11.478,-17.216 -24.125,-20.476 -0.832,-0.253 -3.388,-0.889 -7.679,-1.887 0.095,-0.092 0.226,-0.279 0.463,-0.627 L 58.914,-93.72 c 0.047,0 0.107,-0.151 0.107,-0.374 l 0.119,0.114 c -0.072,-0.067 -0.161,-0.198 -0.226,-0.351 L 43.947,-94.242 0,-43.472 v -50.859 h -1.533 -10.829 c -0.143,-0.11 -0.352,-0.054 -0.618,0.089 V 6.137 Z" /></g>
          </g>
        </svg>
        <span class="ui-gaco-text w-full text-right text-[11.5px] font-bold leading-none tracking-[0.3em]"
          >GACO</span
        >
      </span>
    </a>
    } @else {
    <!-- Mode réduit : marque Proteor compacte (4 quartiers) -->
    <a [routerLink]="home()" class="shrink-0" aria-label="Proteor GACO">
      <svg class="h-8 w-8" viewBox="46 100 312 318" aria-hidden="true">
        <g transform="matrix(1.3333333,0,0,-1.3333333,0,543.344)" fill="#335fb1">
          <g transform="translate(37.8089,233.6636)"><path d="m 0,0 c 0,-13.035 105.446,-8.546 105.446,-8.546 0,0 2.021,104.1 -11.002,104.179 C 45.736,87.64 7.4,48.898 0,0" /></g>
          <g transform="translate(264.2381,233.6636)"><path d="m 0,0 c -0.018,-13.035 -105.464,-8.546 -105.464,-8.546 0,0 -2.009,104.1 11.019,104.179 C -45.754,87.64 -7.406,48.898 0,0" /></g>
          <g transform="translate(37.8089,198.7774)"><path d="m 0,0 c 0,13.041 105.446,8.55 105.446,8.55 0,0 2.021,-104.097 -11.002,-104.18 C 45.736,-87.627 7.4,-48.898 0,0" /></g>
          <g transform="translate(264.2381,198.7774)"><path d="m 0,0 c -0.018,13.041 -105.464,8.55 -105.464,8.55 0,0 -2.009,-104.097 11.019,-104.18 C -45.754,-87.627 -7.406,-48.898 0,0" /></g>
        </g>
      </svg>
    </a>
    }
    <button
      (click)="toggleCollapsed()"
      class="p-1 rounded ui-row-hover transition-colors shrink-0"
      [class.ms-2]="!renderCollapsed()"
      [class.hidden]="!collapseToggleVisible()"
      [attr.title]="collapsed() ? 'Déplier' : 'Plier'"
    >
      <span class="material-icons text-lg"> {{ collapsed() ? 'chevron_right' : 'chevron_left' }} </span>
    </button>
  </div>

  <!-- Menu -->
  <ul class="p-2 space-y-1 flex-1 min-h-0 overflow-y-auto [scrollbar-gutter:stable]">
    <!-- Panier : entrée purement de mutation, masquée pour un lecteur pur (GlobalReader) -->
    @if (user.canCreateRequisitionDraft()) {
    <li><app-cart-badge [collapsed]="renderCollapsed()" /></li>
    }

    <!-- Tout déplier / tout replier : l'utilisateur choisit (les menus ne se replient plus tout seuls
         à l'ouverture d'un autre). Masqué en rail réduit et s'il n'y a aucun groupe. -->
    @if (!renderCollapsed() && hasGroups()) {
    <li class="flex justify-end px-1">
      <button
        type="button"
        (click)="toggleAll()"
        class="inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-medium ui-text-secondary ui-row-hover transition-colors"
        [attr.title]="allExpanded() ? 'Tout replier' : 'Tout déplier'"
      >
        <span class="material-icons text-[15px] leading-none">{{ allExpanded() ? 'unfold_less' : 'unfold_more' }}</span>
        {{ allExpanded() ? 'Tout replier' : 'Tout déplier' }}
      </button>
    </li>
    }

    @for (item of links(); track $index; let i = $index) {

    <!-- Séparateur fin entre groupes (mode réduit) -->
    @if (renderCollapsed() && i > 0) {
    <li aria-hidden="true" class="flex justify-center py-0.5">
      <span class="h-px w-8 bg-(--ui-border-soft)"></span>
    </li>
    }

    <!-- Lien simple -->
    @if (item.url) {
    <li>
      <a
        [routerLink]="item.url"
        routerLinkActive="ui-nav-active"
        [class]="
          'group relative flex rounded-lg ui-row-hover transition-colors font-medium ' +
          (renderCollapsed() ? 'flex-col items-center gap-0.5 px-0.5 py-1.5 text-center' : 'items-center gap-3 px-3 py-2')
        "
      >
        <span class="w-6 h-6 grid place-items-center">
          <span class="material-icons" [class]="renderCollapsed() ? 'text-base' : 'text-lg'">
            {{ item.icon || 'radio_button_unchecked' }}
          </span>
        </span>
        @if (renderCollapsed()) {
        <span class="w-full text-[10px] leading-tight truncate">{{ item.shortName || item.name }}</span>
        } @else {
        <span class="truncate text-sm">{{ item.name }}</span>
        }
        @if (item.badge != null && item.badge > 0) {
        <span
          [class]="
            'inline-flex items-center justify-center rounded-full bg-indigo-600 text-white font-medium ' +
            (renderCollapsed()
              ? 'absolute top-0.5 right-1 min-w-4 h-4 px-1 text-[9px]'
              : 'ms-auto min-w-5 h-5 px-1.5 text-[11px]')
          "
        >
          {{ item.badge }}
        </span>
        }
      </a>
    </li>
    }

    <!-- Groupe avec sous-menus -->
    @if (item.nestedLinks) {
    <li>
      <!-- Parent -->
      <button
        type="button"
        (click)="toggle(i)"
        [class]="
          'w-full flex transition-colors font-semibold ' +
          (renderCollapsed()
            ? 'flex-col items-center gap-0.5 px-0.5 py-1.5 text-center rounded-lg ui-row-hover'
            : 'items-center px-3 py-2 rounded-lg ui-row-hover')
        "
        [attr.aria-expanded]="isOpen(i)"
      >
        <span class="w-6 h-6 grid place-items-center text-(--color-indigo-600)">
          <span class="material-icons" [class]="renderCollapsed() ? 'text-base' : 'text-lg'"> {{ item.icon || 'folder' }} </span>
        </span>

        @if (renderCollapsed()) {
        <span class="w-full text-[10px] leading-tight truncate">{{ item.shortName || item.name }}</span>
        <span
          class="material-icons text-[15px] leading-none opacity-60 transition-transform"
          [class.rotate-180]="isOpen(i)"
          >expand_more</span
        >
        } @else {
        <span class="ms-3 truncate text-sm">{{ item.name }}</span>
        <span class="ms-auto material-icons text-sm transition-transform" [class.rotate-180]="isOpen(i)">
          expand_more
        </span>
        }
      </button>

      <!-- Sous-menus -->
      <div
        class="grid overflow-hidden transition-[grid-template-rows] duration-200 ease-out"
        [style.gridTemplateRows]="isOpen(i) ? '1fr' : '0fr'"
      >
        <ul
          [class]="
            'min-h-0 overflow-hidden space-y-0.5 ' +
            (renderCollapsed() ? 'mt-0.5' : 'ui-nav-rail ms-[18px] ps-2 mt-1')
          "
        >
          @for (nested of item.nestedLinks; track $index) {
          <li>
            <a
              [routerLink]="nested.url"
              routerLinkActive="ui-nav-active"
              [routerLinkActiveOptions]="{ exact: true }"
              [class]="
                'relative flex rounded-lg ui-row-hover transition-colors ' +
                (renderCollapsed() ? 'flex-col items-center gap-0.5 px-0.5 py-1.5 text-center' : 'items-center px-2.5 py-1.5 text-sm')
              "
            >
              <span class="w-6 h-6 grid place-items-center">
                <span class="material-icons" [class]="renderCollapsed() ? 'text-base' : ''"> {{ nested.icon || 'chevron_right' }} </span>
              </span>
              @if (renderCollapsed()) {
              <span class="w-full text-[10px] leading-tight truncate">{{ nested.shortName || nested.name }}</span>
              } @else {
              <span class="ms-3"> {{ nested.name }} </span>
              }
              @if (nested.badge != null && nested.badge > 0) {
              <span
                [class]="
                  'inline-flex items-center justify-center rounded-full bg-indigo-600 text-white font-medium ' +
                  (renderCollapsed()
                    ? 'absolute top-0.5 right-1 min-w-4 h-4 px-1 text-[9px]'
                    : 'ms-auto min-w-5 h-5 px-1.5 text-[11px]')
                "
              >
                {{ nested.badge }}
              </span>
              }
            </a>
          </li>
          }
        </ul>
      </div>
    </li>
    } }
  </ul>

  <div class="px-3 pb-3" [class.hidden]="renderCollapsed()">
    <app-stock-location-picker
      [formField]="stockLocationForm"
      [placeholder]="'Stock de préférence'"
      (onSelect)="onStockLocationChanged($any($event))"
    ></app-stock-location-picker>
  </div>

  <!-- Profil utilisateur -->
  <div class="border-t border-(--ui-border-split) p-3 flex flex-col gap-3 min-w-0" [class.items-center]="renderCollapsed()">
    <button
      type="button"
      class="flex items-center gap-3 flex-1 min-w-0 rounded ui-row-hover py-2 text-left w-full"
      [class.px-2]="!renderCollapsed()"
      [class.justify-center]="renderCollapsed()"
      cdkOverlayOrigin
      #userOrigin="cdkOverlayOrigin"
      [attr.aria-expanded]="userMenuOpen()"
      [attr.aria-haspopup]="true"
      (click)="toggleUserMenu()"
    >
      <!-- Avatar -->
      <span
        class="ui-avatar w-9 h-9 rounded-full flex items-center justify-center text-[13px] font-bold select-none shrink-0"
      >
        @if (user.user(); as u) { {{ (u.firstName?.[0] ?? '') + (u.lastName?.[0] ?? '') | uppercase }} } @else {
        <span class="material-icons text-base">person_off</span>
        }
      </span>

      <!-- Infos -->
      @if (!renderCollapsed()) {
      <div class="overflow-hidden">
        @if (user.user(); as u) {
        <div class="text-sm font-medium truncate">{{ u.firstName }} {{ u.lastName }}</div>
        <div class="ui-text-secondary text-xs truncate">{{ u.email }}</div>
        } @else {
        <div class="text-sm font-medium">Déconnecté</div>
        }
      </div>
      }
    </button>
  </div>

  <!-- Menu flottant -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="userOrigin"
    [cdkConnectedOverlayOpen]="userMenuOpen()"
    [cdkConnectedOverlayPositions]="userMenuPositions"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="closeUserMenu()"
    (detach)="closeUserMenu()"
  >
    <div class="ui-panel z-50 w-56 rounded-lg border shadow-lg overflow-hidden">
      @if (user.user(); as u) {
      <div class="ui-text-secondary px-3 py-2 text-xs border-b border-(--ui-border-split)">
        Connecté en tant que<br /><span class="ui-text-primary font-medium truncate">{{ u.email }}</span>
      </div>
      }

      <ul class="py-1">
        <!-- « Mon profil » retiré : aucune page profil n'existe (app.routes.ts n'a pas de path
             `profile` ; le wildcard redirigeait vers les demandes). L'identité de l'utilisateur est
             déjà affichée dans le pied du sidenav (nom + e-mail). -->
        <li>
          <button type="button" class="w-full text-left px-3 py-2 text-sm ui-row-hover" (click)="openSettings()">
            <span class="material-icons align-middle text-base me-2">settings</span>
            Paramètres
          </button>
        </li>
        <li>
          <button
            type="button"
            class="w-full text-left px-3 py-2 text-sm! ui-row-hover"
            (click)="closeUserMenu(); logout()"
          >
            <span class="material-icons align-middle text-base me-2">logout</span>
            Déconnexion
          </button>
        </li>
      </ul>
    </div>
  </ng-template>
</nav>
